import React from "react";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import { getToolTipAttributes } from "../../../../utils/tooltip";
import { getStatusConfig } from "../../config";
import { EnvironmentFlow } from "../PipelineConfigCard";

const Type = ({ isPromoteType }) => {
  const typeBg = isPromoteType ? "#EEF2FF" : "#ECFDF5";
  const typeColor = isPromoteType ? "#4338CA" : "#047857";
  const typeIconName = isPromoteType ? "rocket_launch" : "trending_up";

  return (
    <div
      style={{
        padding: "6px",
        borderRadius: "8px",
        backgroundColor: typeBg,
        color: typeColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "fit-content",
        boxShadow: "0 1px 2px rgba(0,0,0,0.06)"
      }}
    >
      <MaterialIcon name={typeIconName} style={{ fontSize: "16px" }} />
    </div>
  );
};

const SummaryCell = ({ icon, item, requestType, requestId, reason }) => {
  // 1. Data Extraction
  let source = "";
  let target = "";

  // Handle safely accessing nested objects
  if (requestType === "Promote" && item.promote_request) {
    source = item.promote_request.environment;
    target = item.promote_request.target_environment;
  } else {
    source = item.release_request.environment;
    target = item.release_request.target_environment;
  }

  const status = item?.state || "";
  const config = getStatusConfig(status);

  // 2. Format Date
  const formattedDate = item.created_at
    ? new Date(item.created_at).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      })
    : "N/A";

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "12px" }}>
        {/* Request Type Label */}
        <span
          style={{
            fontWeight: 700,
            textTransform: "uppercase",
            color: "#6B7280",
            letterSpacing: "0.03em",
            display: "flex",
            alignItems: "center",
            gap: "4px"
          }}
        >
          {icon && <MaterialIcon name={icon} style={{ fontSize: "14px", color: config.icon || "#6B7280" }} />}
          {requestType}
        </span>

        {/* Request ID */}
        {requestId && (
          <span
            style={{
              color: "#374151",
              fontFamily: "monospace",
              backgroundColor: "#F3F4F6",
              padding: "0 4px",
              borderRadius: "4px"
            }}
          >
            #{requestId}
          </span>
        )}

        {reason && (
          <div style={{ display: "flex", alignItems: "center", gap: "8px", maxWidth: "100%", overflow: "hidden" }}>
            <span style={{ color: "#D1D5DB" }}>|</span>
            <span
              style={{
                maxWidth: "200px",
                color: "#111827",
                fontWeight: 500,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block"
              }}
              {...getToolTipAttributes(reason)}
            >
              {reason}
            </span>
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "12px",
          marginLeft: "6px", // Offset to align with header text visually
          paddingLeft: "12px",
          borderLeft: "2px solid #E5E7EB" // The connector line
        }}
      >
        <Type isPromoteType={requestType === "Promote"} />

        <div style={{ display: "flex", flexDirection: "column", gap: "4px", paddingTop: "2px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <EnvironmentFlow source={source} target={target} size="sm" />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "11px", color: "#6B7280" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <MaterialIcon name="person" style={{ fontSize: "12px" }} />
              <span>{item.initiater_name || "Unknown"}</span>
            </div>
            <span style={{ color: "#D1D5DB" }}>•</span>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <MaterialIcon name="schedule" style={{ fontSize: "12px" }} />
              <span>{formattedDate}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryCell;
